import { useTranslation } from 'react-i18next';
import { StatusBadge, type StatusBadgeStatus } from '@xxtract/ui';
import type { Trend } from '../data-quality.api';

const TREND_TO_BADGE_STATUS: Record<Trend, StatusBadgeStatus> = {
  improving: 'trend-improving',
  stable: 'trend-stable',
  declining: 'trend-declining',
};

/** FR23/NFR9: trend is always color + icon + label (never color alone). */
export function TrendBadge({ trend }: { trend: Trend }) {
  const { t } = useTranslation();
  return <StatusBadge status={TREND_TO_BADGE_STATUS[trend]} label={t(`dataQuality.trend.${trend}`)} />;
}
